import { IJudgmentPunishmentIndex } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentPunishmentIndex';
import { IKnmJudgmentPunishmentIndexSelectOption } from '../interfaces/IKnmJudgmentPunishmentIndexSelectOption';

export const createJudgmentPunishmentIndexSelectOption = (
  erknmJudgmentPunishmentIndex: IJudgmentPunishmentIndex,
): IKnmJudgmentPunishmentIndexSelectOption => ({
  ...erknmJudgmentPunishmentIndex,
  label: erknmJudgmentPunishmentIndex.name,
  value: erknmJudgmentPunishmentIndex.id,
  punishmentTypeIds: erknmJudgmentPunishmentIndex.punishmentTypeIds,
});
